/**
 * United MileagePlus number formats (8-char and legacy 11-digit).
 * Keep in sync with apple-sign-in/src/mileage-plus/is-valid-mileage-plus-number.ts
 */
export const MILEAGE_PLUS_NUMBER_PATTERN =
  /^(?:[A-Z][A-Z0-9]{2}[0-9][A-Z0-9]{3}[0-9]|[0][0-9]{10})$/;

export const normalizeMileagePlusNumber = (membershipId: string): string =>
  membershipId.trim().toUpperCase();

export const isValidMileagePlusNumber = (membershipId: string): boolean =>
  MILEAGE_PLUS_NUMBER_PATTERN.test(normalizeMileagePlusNumber(membershipId));
